const handlings = {
  "bubble wrap": "Bubble Wrap",
  plastic: "Plastik",
  cardboard: "Kardus",
  wood: "Kayu",
  pallete: "Pallet",
  "sandbag sm": "Karung Kecil",
  "sandbag md": "Karung Sedang",
  "sandbag l": "Karung Besar"
};
export { handlings };
